// import { ApiService } from 'src/app/services/api.service';
// import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
// import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
// import { Component, OnInit, ViewChild } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { ErrorMessage } from 'src/app/models/ErrorMessages';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { HeaderComponent } from "../header/header.component";
// import { ReactiveFormsModule } from '@angular/forms';
// import { TimepickerModule } from 'ngx-bootstrap/timepicker';
// import { LocalstorageService } from 'src/app/services/localstorage.service';

// @Component({
//   selector: 'app-register',
//   standalone: true,
//   imports: [
//     BsDatepickerModule,
//     CommonModule,
//     HeaderComponent,
//     ReactiveFormsModule,
//     TimepickerModule
//   ],
//   providers: [BsModalRef, BsModalService],
//   templateUrl: './register.component.html',
//   styleUrl: './register.component.scss'
// })
// export class RegisterComponent implements OnInit {

//   @ViewChild('exampleModalCenter') failureTemplate: any
//   modalRef: BsModalRef<any> | undefined;
//   registrationForm: FormGroup
//   headerMessage: string = ''
//   bodyMessage: string = ''
//   baseCenterMapping = [
//     {city: "Banglore", centers: ["Yelahanka", "Kalyan Nagar", "Koramangala", "Jaya Nagar", "Malleshwaram", "Accolite office"]},
//     {city: "Chennai", centers: []},
//     {city: "Hyderabad", centers: []},
//     {city: "Gurgaon", centers: []},
//     {city: "Mumbai", centers: []},
//   ]
//   selectedBaseCenter: any
//   packages: any[] = []; // Array to hold packages data
//   meridians = ['AM', 'PM'];
//   minDate: string = ''
//   errorMessages = ErrorMessage

//   constructor(
//     private modalService: BsModalService,
//     private apiService: ApiService,
//     private formBuilder: FormBuilder,
//     private localStorageService: LocalstorageService
//   ) {
//     this.registrationForm = this.formBuilder.group({
//       name: ['', Validators.required],
//       age: ['', Validators.required],
//       gender: [''],
//       mobileNumberPrimary: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
//       mobileNumberAlternate: [''],
//       email: [this.localStorageService.getEmailFromLocalStorage()],
//       existingAilment: ['', Validators.required],
//       baseLocation: [''],
//       centerLocation: [''],
//       checkupDate: [''],
//       checkupTime: [''],
//       package: [''] // New form control for package
//     });
//   }

//   ngOnInit(): void {
//     const today = new Date().toISOString().split('T')[0];
//     this.minDate = today;
//     this.fetchPackages(); // Fetch packages data
//   }

//   // Fetch packages data
//   fetchPackages(): void {
//     this.apiService.getPackages().subscribe(
//       (response) => {
//         this.packages = response; // Assuming the response has a `data` field
//       },
//       (error) => {
//         console.error('Error fetching packages:', error);
//       }
//     );
//   }

//   selectOption(event: Event, gender: string) {
//     const selectedValue = (event.target as HTMLSelectElement).value;
//     if (gender) {
//       this.registrationForm.get('gender')?.setValue(selectedValue);
//     } else {
//       this.selectedBaseCenter = this.baseCenterMapping.filter((city) => city.city === selectedValue)[0];
//       console.log(this.selectedBaseCenter?.centers);
//     }
//   }

//   openModal(success: boolean, header: string, body: string) {
//     this.modalRef = this.modalService.show(this.failureTemplate);
//     this.headerMessage = success ? '✅' + header : '❌' + header;
//     this.bodyMessage = body;
//   }

//   timeCalculation() {
//     return this.registrationForm.get('checkupTime')?.value?.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
//   }

//   validate() {
//     const registerParams = {
//       email: this.registrationForm.get('email')?.value,
//       name: this.registrationForm.get('name')?.value,
//       empCode: this.registrationForm.get('name')?.value,
//       age: this.registrationForm.get('age')?.value,
//       sex: this.registrationForm.get('gender')?.value,
//       phoneNumber: this.registrationForm.get('mobileNumberPrimary')?.value,
//       existingAilment: this.registrationForm.get('existingAilment')?.value,
//       baseLocation: this.registrationForm.get('baseLocation')?.value,
//       center: this.registrationForm.get('centerLocation')?.value,
//       checkupDate: this.registrationForm.get('checkupDate')?.value,
//       checkupTime: this.timeCalculation(),
//       testPackageId: this.registrationForm.get('package')?.value // Include package in the request
//     };

//     this.apiService.registerNew(registerParams).subscribe(
//       (res: any) => {
//         this.openModal(true, "success", "Successfully registered for Checkup");
//         this.registrationForm.reset();
//       },
//       (error: any) => {
//         this.openModal(false, "Failure", "Unable to do the registration");
//       }
//     );
//   }
// }


import { ApiService } from 'src/app/services/api.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorMessage } from 'src/app/models/ErrorMessages';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HeaderComponent } from "../header/header.component";
import { ReactiveFormsModule } from '@angular/forms';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { LocalstorageService } from 'src/app/services/localstorage.service';

@Component({
    selector: 'app-register',
  standalone: true,
  imports: [
    BsDatepickerModule,
    CommonModule,
    HeaderComponent,
    ReactiveFormsModule,
    TimepickerModule
  ],
  providers: [BsModalRef, BsModalService],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent implements OnInit {
  @ViewChild('exampleModalCenter') failureTemplate: any;
  modalRef: BsModalRef<any> | undefined;
  registrationForm: FormGroup;
  headerMessage: string = '';
  bodyMessage: string = '';
  baseCenterMapping = [
    { city: "Banglore", centers: ["Yelahanka", "Kalyan Nagar", "Koramangala", "Jaya Nagar", "Malleshwaram", "Accolite office"] },
    { city: "Chennai", centers: ["Anna Nagar", "Besant Nagar", "Mylapore", "Gopalapuram"] },
    { city: "Hyderabad", centers: ["Jubilee Hills", "Banjara Hills", "Gachibowli", "HITEC City"] },
    { city: "Gurgaon", centers: ["Palam Vihar", "Sector 106", "Nirvana Country", "Golf Course Extension", "Sohna Road"] },
    { city: "Mumbai", centers: ["Borivali", "Bandra", "Malad", "Dadar"] },
  ];
  selectedBaseCenter: any;
  packages: any[] = [];
  meridians = ['AM', 'PM'];
  minDate: string = '';
  errorMessages = ErrorMessage;

  constructor(
    private modalService: BsModalService,
    private apiService: ApiService,
    private formBuilder: FormBuilder,
    private localStorageService: LocalstorageService
  ) {
    this.registrationForm = this.formBuilder.group({
      name: ['', Validators.required],
      age: ['', [Validators.required, Validators.min(1)]],
      gender: ['', Validators.required],
      mobileNumberPrimary: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      mobileNumberAlternate: [''],
      email: [this.localStorageService.getEmailFromLocalStorage()],
      existingAilment: [''],
      baseLocation: ['', Validators.required],
      centerLocation: ['', Validators.required],
      checkupDate: ['', Validators.required],
      checkupTime: ['', Validators.required],
      package: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    const today = new Date().toISOString().split('T')[0];
    this.minDate = today;
    this.fetchPackages();
  }

  fetchPackages(): void {
    this.apiService.getPackages().subscribe(
      (response) => {
        this.packages = response;
      },
      (error) => {
        console.error('Error fetching packages:', error);
      }
    );
  }

  selectOption(event: Event, gender: string) {
    const selectedValue = (event.target as HTMLSelectElement).value;
    if (gender) {
      this.registrationForm.get('gender')?.setValue(selectedValue);
    } else {
      this.selectedBaseCenter = this.baseCenterMapping.filter((city) => city.city === selectedValue)[0];
      console.log(this.selectedBaseCenter?.centers);
    }
  }

  validate(): void {
    if (this.registrationForm.invalid) {
      this.registrationForm.markAllAsTouched();
      return;
    }

    const registerParams = {
      email: this.registrationForm.get('email')?.value,
      name: this.registrationForm.get('name')?.value,
      age: this.registrationForm.get('age')?.value,
      sex: this.registrationForm.get('gender')?.value,
      phoneNumber: this.registrationForm.get('mobileNumberPrimary')?.value,
      existingAilment: this.registrationForm.get('existingAilment')?.value,
      baseLocation: this.registrationForm.get('baseLocation')?.value,
      center: this.registrationForm.get('centerLocation')?.value,
      checkupDate: this.registrationForm.get('checkupDate')?.value,
      checkupTime: this.registrationForm.get('checkupTime')?.value?.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
      testPackageId: this.registrationForm.get('package')?.value
    };

    this.apiService.registerNew(registerParams).subscribe(
      (res: any) => {
        this.openModal(true, "Success", "Successfully registered for Checkup");
        this.registrationForm.reset();
      },
      (error: any) => {
        this.openModal(false, "Failure", "Unable to complete the registration");
      }
    );
  }

  openModal(success: boolean, header: string, body: string): void {
    this.modalRef = this.modalService.show(this.failureTemplate);
    this.headerMessage = success ? '✅ ' + header : '❌ ' + header;
    this.bodyMessage = body;
  }
}